module.exports = __webpack_public_path__ + "static/trophy-c015c9c12383d2748e608e6a14fbc29e.jpg";